import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import {
  BrandVariants,
  createLightTheme,
  FluentProvider,
  Theme,
} from "@fluentui/react-components";
import "./config/i18n";
import "./index.css";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const ata: BrandVariants = {
  10: "#030206",
  20: "#151528",
  30: "#1E2147",
  40: "#252B63",
  50: "#323773",
  60: "#41437D",
  70: "#505087",
  80: "#5F5E91",
  90: "#6D6C9B",
  100: "#7C7AA5",
  110: "#8A88AF",
  120: "#9997B9",
  130: "#A8A6C4",
  140: "#B7B5CE",
  150: "#C6C5D9",
  160: "#D6D4E3",
};

const lightTheme: Theme = {
  ...createLightTheme(ata),
};

root.render(
  <React.StrictMode>
    <FluentProvider theme={lightTheme}>
      <App />
    </FluentProvider>
  </React.StrictMode>
);
